module.exports = __webpack_public_path__ + "img/4_10.b31b1cdf.png";